import { render, staticRenderFns } from "./DocumentDownload.vue?vue&type=template&id=db9894a8&scoped=true"
import script from "./DocumentDownload.vue?vue&type=script&lang=js"
export * from "./DocumentDownload.vue?vue&type=script&lang=js"
import style0 from "./DocumentDownload.vue?vue&type=style&index=0&id=db9894a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9894a8",
  null
  
)

export default component.exports